

const React = require('react');
const Link = require('react-router-dom').Link;
const connect = require('react-redux/dist/react-redux.min.js').connect;
const ReduxStore = require('./../redux/reduxStore.jsx.js');
const AjaxFunctions = require('./../ajaxFunctions');
const Utils = require('../utils');
const SharedConstants = require('../../../../shared/sharedConstants');
const UserSearch = require('./userSearch.jsx').UserSearch;
const TextInputModal = require('./textInputModal.jsx').TextInputModal;
const ToastAlert = require('./toastAlert');
const PortfolioActivityLog = require('./portfolioActivityLog.jsx').PortfolioActivityLog;
import Toastr from "toastr";

import {
   Tabs,
   Tab
} from '@material-ui/core';

class PortfolioManagerBase extends React.Component{
   constructor(props) {
      super(props);
      this.state ={
         deckList: [],
         tab: 0,
      }
   }

   async getDeckInfo(){
      let deckList = await AjaxFunctions.getDecks();
      this.setState({deckList});
   }

   componentDidMount(){
      this.getDeckInfo();
   }

   reloadCurPortfolio(){
      AjaxFunctions.getPortfolioById(this.props.curPortfolio.id).then((curPortfolioData) =>{
         ReduxStore.store.dispatch(ReduxStore.PortfolioFunctions.setCurPortfolio(curPortfolioData));
      })
   }

   inviteUser(idUser){
      AjaxFunctions.addPortfolioUser(this.props.curPortfolio.id, idUser).then(() => {
         this.reloadCurPortfolio();
      },(err) => console.log(err))

   }

   uninviteUser(idUser){
      AjaxFunctions.removePortfolioUser(this.props.curPortfolio.id, idUser).then(() => {
         this.reloadCurPortfolio();
      },(err) => console.log(err))

   }

   render() {
      const { tab } = this.state;
      const { hideTabsFromNonOwners = false } = this.props;

      let tabStyle = {
        minWidth: 50,
        paddingLeft: 0,
        paddingRight: 0,
      };
      
      let userSearch = () => {
         if(this.props.curPortfolio.idOwner === parseInt(window.globals.idUser)) {
            return (
               <div>
                  <div className="leading">Invite people to your project</div>
                  <UserSearch
                     userBtnFunction={(idUser) => this.inviteUser(idUser)}
                     userBtnText={'Invite'}
                  />
               </div>
            )
         }
      };

      let hideNonOwnerTabs = hideTabsFromNonOwners 
         && parseInt(this.props.curPortfolio.idOwner) !== parseInt(window.globals.idUser);

      return (
         <div>
            <Tabs
               value={tab}
               onChange={(event, value) => this.setState({ tab: value })}
               indicatorColor='primary'
               textColor='primary'
               variant='fullWidth'
               centered
            >
               <Tab className='material-button' style={{...tabStyle, textTransform: 'none'}} label={`ADD ${String.fromCharCode(181)}PUBS`} />
               {!hideNonOwnerTabs && <Tab className='material-button' style={tabStyle} label='Activity' />}
               {!hideNonOwnerTabs && <Tab className='material-button' style={tabStyle} label='Share' />}
               {!hideNonOwnerTabs && <Tab className='material-button' style={tabStyle} label='Synthesis' />}
            </Tabs>
            {tab == 0 && 
               <div className='tab-pane'>
                  <CardList
                     deckList={this.state.deckList}
                     idPortfolio={this.props.curPortfolio.id}
                     tagList={this.props.tagList}
                     tagFilterList={this.props.tagFilterList}
                     addCardToPortfolio={this.props.addCardToPortfolio}
                     setWorkspaceFilterListFunction={this.props.setWorkspaceFilterListFunction}
                     addCommentOnCardAdd={this.props.addCommentOnCardAdd}
                  /> 
               </div>
            }
            {tab == 1 &&
               <div className='tab-pane'>
                  <PortfolioActivityLog
                     logData={this.props.curPortfolio.logData}
                  />
               </div>
            }
            {tab == 2 &&
               <div className='tab-pane'>
                  {userSearch()}
                  <UserList
                     showAdminButton={this.props.curPortfolio.idOwner === parseInt(window.globals.idUser)}
                     userArray={this.props.curPortfolio.userData}
                     uninviteUserFunction={(idUser) => this.uninviteUser(idUser)}
                  />
               </div>
            }
            {tab == 3 &&
               <div className='tab-pane'>
                  <SynthesisSelector
                     alreadyUsedTemplates={this.props.curPortfolio.items.filter(x => x.cardType=== SharedConstants.CardType.Synthesis)}
                     templates={this.props.synthesisTemplates}
                     addSynthesis={(idTemplate) => this.props.addSynthesis(idTemplate, this.props.curPortfolio.id)}
                  />
               </div>
            }
         </div>
      );
   }
}


class CardList extends React.Component{
   constructor(props) {
      super(props);
      this.state={
         showUntagged: false,
         cardToAdd: null,
      }
   }

   async addCardToPortfolio(card, commentText = null) {
      try {
         await this.props.addCardToPortfolio(
            this.props.idPortfolio,
            card.id,
            card.cardType,
            commentText
         );
      }
      catch(err){
         ToastAlert.error(err);
      }
      this.setState({cardToAdd: null});
   }

   onAddButtonClicked(card){
      this.addCardToPortfolio(card);
   }

   onTagClicked(tag) {
      let selectedTagList = this.props.tagFilterList.slice();
      let tagExists = false;
      for(let i = 0; i < selectedTagList.length; i++){
         if(selectedTagList[i] === tag){
            selectedTagList.splice(i,1);
            tagExists = true;
            break;
         }
      }
      if(!tagExists){
         selectedTagList.push(tag);
      }
      this.props.setWorkspaceFilterListFunction(selectedTagList);
   }

   removeCardFromPortfolio(card) {
      this.props.removeCardFromPortfolio(this.props.idPortfolio, card.id, card.cardType);
   }

   toggleShowUntagged(){
      this.setState({showUntagged: !this.state.showUntagged});
   }

   render() {
      let cardList = [];
      if(this.props.deckList.length > 0){
         cardList = Object.values(this.props.deckList[0].cards);
      }

      let filteredCardList = Object.values(cardList).filter((card) => {
         if(card.workspaceTags.length === 0)
            return this.state.showUntagged;

         for(let tagFilter of this.props.tagFilterList){
            if(card.workspaceTags.indexOf(tagFilter) > -1)
               return true;
         }
         return false;
      });

      let cards = filteredCardList.map((card) => {
         return(
            <div key={card.id} className='portfolio-manager-list-row'>
               <button className='btn btn-primary' onClick={() => this.onAddButtonClicked(card)}>
                  Add
               </button>
               <div
                  className={'dashboard-row-content ' + (card.cardType===SharedConstants.CardType.Reasoning ? 'list-view-conjecture-row-content': '')}>
                  {card.title}
               </div>
            </div>
         )
      });

      let tags = this.props.tagList.map((tag) => {
         return(
            <button
               key={tag}
               className={'btn ' + (this.props.tagFilterList.indexOf(tag) > -1 ? 'btn-dark': 'btn-outline-secondary')}
               onClick={() => this.onTagClicked(tag)}
            >
               {tag}
            </button>
         )
      });
      return (
         <div>
            <div className='workspace-tag-container'>
               <h6>Viewing Favorited &micro;Pubs with the following tags. Click to toggle.</h6>
               {tags}
            </div>
            <div>
               <input type='checkbox' checked={this.state.showUntagged} onChange={() => this.toggleShowUntagged()} /> <label>Show &micro;Pubs without any tags</label>
            </div>
            <div id='portfolioManagerCardList'>
               {cards}
            </div>
         </div>
      );
   }
}

const mapPortfolioManagerStateToProps = (state) => {

   return {
      curPortfolio: state.PortfolioReducer.curPortfolio,
      tagList: state.WorkspaceTagReducer.tagList,
      tagFilterList: state.WorkspaceTagReducer.filterList,
      synthesisTemplates :  state.PortfolioReducer.synthesisTemplates,
   }
};

const mapPortfolioManagerDispatchToProps = (dispatch) => {
   return {
      addCardToPortfolio: async (idPortfolio, idCard, cardType, comment = null) => {

         await AjaxFunctions.addCardToEndOfPortfolio(idPortfolio, idCard, cardType, comment);

         let portfolioData = await AjaxFunctions.getUserPortfolios();
         dispatch(ReduxStore.PortfolioFunctions.setPortfolioList(portfolioData));

         //this is a bit too much of a hack for my liking, but it shouldn't cause any conflicts and we're probably going
         //to get rid of the side bar soon anyway.
         if(window.location.href.includes('incubator')){
            let curPortfolioData = await AjaxFunctions.getIncubatorById(idPortfolio);
            dispatch(ReduxStore.PortfolioFunctions.setCurPortfolio(curPortfolioData));
         }
         else{
            let curPortfolioData = await AjaxFunctions.getPortfolioById(idPortfolio);
            dispatch(ReduxStore.PortfolioFunctions.setCurPortfolio(curPortfolioData));
         }
      },
      setWorkspaceFilterListFunction: (filterList) => {
         dispatch(ReduxStore.WorkspaceTagFunctions.setFilterList(filterList))
      },
      addSynthesis: async (idTemplate, idPortfolio) => {
         await AjaxFunctions.createSynthesis(idTemplate, idPortfolio);
         let portfolioData = await AjaxFunctions.getUserPortfolios();
         let curPortfolioData = await AjaxFunctions.getPortfolioById(idPortfolio);
         dispatch(ReduxStore.PortfolioFunctions.setCurPortfolio(curPortfolioData));
         dispatch(ReduxStore.PortfolioFunctions.setPortfolioList(portfolioData));
      }
   }
};

export default connect(
   mapPortfolioManagerStateToProps,
   mapPortfolioManagerDispatchToProps
)(PortfolioManagerBase);

class UserList extends React.Component{
   constructor(props) {
      super(props);
      this.state={
      }
   }

   render() {
      if(this.props.userArray ){
         let users = this.props.userArray.map((user) => {
            let adminButton = () => {
               if(this.props.showAdminButton){
                  return(
                     <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.uninviteUserFunction(user.idUser)}>
                        Remove
                     </button>
                  )
               }
            };
            return(
               <li className="list-group-item d-flex justify-content-between align-items-center" key={user.idUser}>
                  <div className="user d-flex align-items-center">
                     <div className="avatar" />
                     <a className="user-name" href="#">{user.firstName + ' ' + user.lastName }</a>
                  </div>
                  {adminButton()}
               </li>
            )
         });
         return(

            <div className={''}>
               <div className="leading">
                  Sharing With {this.props.userArray.length} User{(this.props.userArray.length !== 1)?'s':''}
               </div>
               <ul className="list-group">
                  {users}
               </ul>
            </div>
         )
      }
      return <div className={'user-search-results'} />
   }
}

class SynthesisSelector extends React.Component{
   constructor(props) {
      super(props);
      this.state={
      }
   }

   render() {
      if(this.props.templates.length > 0 ){
         let templates = this.props.templates.map((template) => {
            let btnClass = 'btn-primary';
            let btnOnClick = () => {
               this.props.addSynthesis(template.id);
               document.getElementById('displayPageContainer').scrollTo(0,0);
            };
            //cards in the portfolio don't carry the info about what template they use, so we can't match by id
            //there aren't many templates, so a string comparison is fine for now.
            if(this.props.alreadyUsedTemplates.filter(x => x.title === template.title).length !== 0){
               btnClass = 'disabled';
               btnOnClick = () => {
                  Toastr.options.positionClass = 'toast-bottom-full-width';
                  Toastr.error('Already in use.');
               };
            }
            return(
               <div key={template.id} className='portfolio-manager-list-row'>
                  <button className={`btn ${btnClass}`} onClick={btnOnClick}>
                     Add
                  </button>
                  <div
                     className={'dashboard-row-content list-view-conjecture-row-content'}>
                     {template.title}
                  </div>
               </div>
            )
         });
         return(

            <div className={''}>
               <div className="leading">
                  Add a question to help structure your portfolio.
               </div>
               <div className="">
                  {templates}
               </div>
            </div>
         )
      }
      return <div className={'user-search-results'} />
   }
}
